import { useQuery, ApolloQueryResult } from '@apollo/client';

import { GetRewardsV2Document } from 'src/gql/graphql';
import type { GetRewardsV2Query } from 'src/gql/graphql';
import { formatBirthdayForRewards } from 'shared/helpers/rewards';

type UseGetRewardsProps = {
  dispensaryId?: string;
  enterpriseId?: string;
  isoRegionCode?: string;
  birthday: string;
  pin: string;
  phone: string;
  skip?: boolean;
  customerId?: string;
};

type UseGetRewardsReturn = {
  data: GetRewardsV2Query | undefined;
  loading: boolean;
  refetch: () => Promise<ApolloQueryResult<GetRewardsV2Query>>;
};

export const useGetRewards = ({
  dispensaryId,
  enterpriseId,
  isoRegionCode,
  birthday,
  pin = '',
  phone,
  skip = false,
  customerId,
}: UseGetRewardsProps): UseGetRewardsReturn => {
  const skipQuery = skip || (!dispensaryId && !enterpriseId);
  const dob = formatBirthdayForRewards(birthday);

  const { data, loading, refetch } = useQuery(GetRewardsV2Document, {
    variables: {
      phoneNumber: phone,
      dispensaryId,
      enterpriseId,
      isoRegionCode,
      dob,
      pin,
      customerId,
    },
    fetchPolicy: 'network-only',
    skip: skipQuery,
  });

  return {
    data,
    loading,
    refetch,
  };
};
